import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import { apiFetch } from '../api/httpClient';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false); // ✅ Nuevo estado para el spinner
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');
    setCargando(true); // ✅ Activamos el spinner

    try {
      const data = await apiFetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      localStorage.setItem('token', data.token);
      localStorage.setItem('usuario', JSON.stringify(data.usuario));
      setMensaje('✅ Sesión iniciada correctamente');
      navigate('/admin', { replace: true });
    } catch (err) {
      console.error('❌ Login fallido:', err);

      if (err.message.includes('429')) {
        setError('⏳ Demasiados intentos fallidos. Espera un momento.');
      } else if (err.message.includes('401')) {
        setError('❌ Credenciales incorrectas');
      } else {
        setError(
          err.message
            .replace(/^Error:\s*/i, '')   // quita "Error: " al inicio, sin importar mayúsculas
            .replace(/["{}]/g, '')        // quita comillas y llaves
            .trim()                       // elimina espacios extras
        );

      }
    } finally {
      setCargando(false); // ✅ Lo apagamos cuando termina todo
    }
  };

  return (
    <div className="login-page">
      <div className="admin-heading-box">
        <h1 className="admin-heading">Área de Administradores</h1>
        <p className="admin-subtitle">Accede para subir noticias o actas de pleno</p>
      </div>

      <div className="login-container">
        <h2 className="login-title">Iniciar Sesión</h2>
        <form onSubmit={handleLogin} className="login-form">
          <label>Correo electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={cargando}>
            {cargando ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        {mensaje && <p className="success-msg">{mensaje}</p>}
        {error && <p className="error-msg">{error}</p>}

        <button
          className="forgot-password-btn"
          onClick={() => navigate('/login/forgot-password')}
        >
          ¿Olvidaste tu contraseña?
        </button>

        <button
          className="go-home-btn"
          onClick={() => navigate('/')}
        >
          <FaHome style={{ marginRight: '8px' }} />
          Volver al inicio
        </button>
      </div>
    </div>
  );
}
